import Icon from "./Icon";

/*
  Figma "App icon · აპის ხატულა": the app's base colour under a soft white
  sheen, its glyph on top. `app` is a Figma name or a catalog id. Colours are
  full class names so Tailwind keeps them.
*/
export const APP_COLORS = {
  "creator-rewards": { deep: "bg-app-creator-rewards-deep", base: "bg-app-creator-rewards-base", soft: "bg-app-creator-rewards-soft", label: "text-app-creator-rewards-soft", on: "text-app-creator-rewards-on" },
  courses: { deep: "bg-app-courses-deep", base: "bg-app-courses-base", soft: "bg-app-courses-soft", label: "text-app-courses-soft", on: "text-app-courses-on" },
  cloud: { deep: "bg-app-cloud-deep", base: "bg-app-cloud-base", soft: "bg-app-cloud-soft", label: "text-app-cloud-soft", on: "text-app-cloud-on" },
  consulting: { deep: "bg-app-consulting-deep", base: "bg-app-consulting-base", soft: "bg-app-consulting-soft", label: "text-app-consulting-soft", on: "text-app-consulting-on" },
  gateway: { deep: "bg-app-gateway-deep", base: "bg-app-gateway-base", soft: "bg-app-gateway-soft", label: "text-app-gateway-soft", on: "text-app-gateway-on" },
  live: { deep: "bg-app-live-deep", base: "bg-app-live-base", soft: "bg-app-live-soft", label: "text-app-live-soft", on: "text-app-live-on" },
  chat: { deep: "bg-app-chat-deep", base: "bg-app-chat-base", soft: "bg-app-chat-soft", label: "text-app-chat-soft", on: "text-app-chat-on" },
  shop: { deep: "bg-app-shop-deep", base: "bg-app-shop-base", soft: "bg-app-shop-soft", label: "text-app-shop-soft", on: "text-app-shop-on" },
};

export const APP_GLYPHS = {
  "creator-rewards": "gift",
  courses: "book",
  cloud: "cloud",
  consulting: "video",
  gateway: "link",
  live: "broadcast",
  chat: "message",
  shop: "bag",
};

/** Catalog ids that differ from the Figma name. */
const ALIASES = { "mintly-cloud": "cloud", "live-stream": "live" };

export const appKey = (id) => ALIASES[id] || id;

const AppIcon = ({ app, size = 64, glyph, radius, className = "" }) => {
  const key = appKey(app);
  const colors = APP_COLORS[key];
  if (!colors) return null;
  return (
    <span
      className={`relative flex shrink-0 items-center justify-center overflow-hidden ${colors.base} ${colors.on} ${className}`}
      style={{ width: size, height: size, borderRadius: radius ?? Math.round(size * 0.31) }}
    >
      <span className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.22),rgba(255,255,255,0)_60%)]" aria-hidden="true" />
      <Icon name={APP_GLYPHS[key]} size={glyph ?? Math.round(size / 2)} className="relative" />
    </span>
  );
};

export default AppIcon;
